import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { defineStore } from 'pinia';
import { useRequestStore } from './request';

export const useSessionStore = defineStore('session', () => {
    const home = 'order';
    const requestStore = useRequestStore();
    const router = useRouter();
    const token = ref<string>('');
    const user = ref<object>();

    function getUserFromLocalStorage() {
        if (window.localStorage.getItem('token')) {
            token.value = window.localStorage.getItem('token');
        }

        if (window.localStorage.getItem('user')) {
            user.value = JSON.parse(window.localStorage.getItem('user'));
        }
    }

    async function logUserIn(email, password) {
        await requestStore.post('login', {
            email: email,
            password: password,
        }).then((response: any) => {
            const data = response.data;

            token.value = data.token;
            user.value = data.user;

            window.localStorage.setItem('token', data.token);
            window.localStorage.setItem('user', JSON.stringify(data.user));

            router.push({ name : 'order' });
        });
    }

    async function logUserInByToken(loginToken) {
        await requestStore.post('login/' + loginToken, {}).then((response: any) => {
            const data = response.data;

            token.value = data.token;
            user.value = data.user;

            const originalToken = window.localStorage.getItem('token');
            const originalUser = window.localStorage.getItem('user');

            window.localStorage.setItem('originalToken', originalToken);
            window.localStorage.setItem('originalUser', originalUser);
            window.localStorage.setItem('token', data.token);
            window.localStorage.setItem('user', JSON.stringify(data.user));

            router.push({ name : 'order' });
        });
    }

    function logUserOut() {
        const originalToken = window.localStorage.getItem('originalToken');
        const originalUser = window.localStorage.getItem('originalUser');

        if (originalToken && originalUser) {
            token.value = originalToken;
            user.value = JSON.parse(originalUser);

            window.localStorage.removeItem('originalToken');
            window.localStorage.removeItem('originalUser');
            window.localStorage.setItem('token', originalToken);
            window.localStorage.setItem('user', originalUser);

            router.push({name: 'users'});
        } else {
            token.value = '';
            user.value = null;

            window.localStorage.removeItem('token');
            window.localStorage.removeItem('user');

            router.push({name: 'login'});
        }
    }

    async function refreshUser() {
        if (!user.value?.id) {
            return {};
        }

        await requestStore.get('users/' + user.value.id + '?include=group', {
            headers: {
                Authorization: `Bearer ${token.value}`
            }
        }).then((response: any) => {
            user.value = response.data;
        });

        window.localStorage.setItem('user', JSON.stringify(user.value));
    }

    async function registerUser(accepted, email, firstname, lastname, password, phone) {
        await requestStore.post('register', {
            accepted: accepted,
            email: email,
            firstname: firstname,
            lastname: lastname,
            password: password,
            phone: phone,
        }).then((response: any) => {
            const data = response.data;

            token.value = data.token;
            user.value = data.user;

            window.localStorage.setItem('token', data.token);
            window.localStorage.setItem('user', JSON.stringify(data.user));

            router.push({ name : 'order' });
        });
    }

    async function resetPassword(email, password, passwordConfirmation, token) {
        await requestStore.post('password/reset', {
            email: email,
            password: password,
            password_confirmation: passwordConfirmation,
            token: token,
        }).then((response: any) => {
            requestStore.redirect({ name : 'login' }, {});
        });
    }

    async function sendPasswordReset(email) {
        await requestStore.post('password/email', {
            email: email,
        }).then((response: any) => {
            requestStore.redirect(
                { name : 'password-email', query : { email : email } },
                {}
            );
        }).catch(error => Promise.reject(error));
    }

    async function setResetToken(code, email) {
        await requestStore.post('password/token', {
            code: code,
            email: email,
        }).then((response: any) => {
            const code = JSON.parse(response.data.token);

            if (code.token) {
                requestStore.redirect(
                    {
                        name : 'reset-password',
                        query : { email : code.email },
                        params: { token : code.token }
                    },
                    {}
                );
            }
        }).catch(error => Promise.reject(error));
    }

    onMounted(async () => {
        if (!user.value) {
            getUserFromLocalStorage();
        }

        await refreshUser();
    });

    return {
        getUserFromLocalStorage,
        home,
        logUserIn,
        logUserInByToken,
        logUserOut,
        registerUser,
        refreshUser,
        resetPassword,
        sendPasswordReset,
        setResetToken,
        token,
        user
    }
});
